import wait from '../common/utils/wait';
export const mapOgToV2Path = {
    '/account/dashboard': '/account/dashboard',
    '/account/settings/profile': '/account/settings/profile',
    '/account/settings/account': '/account/settings/account',
    '/account/settings/room': '/account/settings/room',
    '/account/settings/notifications': '/account/settings/preferences',
    '/account/settings/legal': '/account/settings/baa',
};
export var ExplicitQueryParams;
(function (ExplicitQueryParams) {
    ExplicitQueryParams["passcode"] = "passcode";
    ExplicitQueryParams["l"] = "l";
})(ExplicitQueryParams || (ExplicitQueryParams = {}));
/**
 * Redirect to a page in Apollo.
 * @param {string} v2Prefix comes from config, should be 'v2'.
 * @param {string} path e.g. 'dashboard' or 'check-in/a-room-slug'.
 * @returns Promise to give enough time for the redirect to happen.
 */
export const redirectToApollo = async (v2Prefix, path, passcode, lang, queryParams) => {
    /**
     * Currently there is a prefix for v2 on live envs,
     * which is defined in next.config.js in core repository.
     */
    const redirectUrl = new URL(`${window.location.origin}/${v2Prefix}${mapOgToV2Path[path] ?? path}`);
    if (Boolean(passcode) && !redirectUrl.searchParams.has('passcode')) {
        redirectUrl.searchParams.append(ExplicitQueryParams.passcode, passcode);
    }
    if (Boolean(lang) && !redirectUrl.searchParams.has('l')) {
        redirectUrl.searchParams.append(ExplicitQueryParams.l, lang);
    }
    /*
     * Forward all query parameters, but skip the explicit query parameters
     * since they are inside the host path, not the queryParams object
    */
    if (queryParams) {
        for (const [key, value] of Object.entries(queryParams)) {
            if (key !== ExplicitQueryParams.passcode && key !== ExplicitQueryParams.l) {
                redirectUrl.searchParams.append(key, value);
            }
        }
    }
    window.location.href = redirectUrl.toString();
    /**
     * @issue https://doxyme.atlassian.net/browse/CS-10681
     * There is a small delay happens when browser actually start the redirect and
     * at that moment component became visible for less then a second(kind of blinking).
     * It is a hack to wait until browser starts handling it.
     */
    const WAIT_FOR_REDIRECT_INTERVAL = 10000;
    await wait(WAIT_FOR_REDIRECT_INTERVAL);
};
